import Vue from 'vue';
import Component from 'vue-class-component';
import SketchfabFrame from '../sketchfabFrame/SketchfabFrame.vue';
import { Prop, Inject } from 'vue-property-decorator';
import { ConfiguratorService, ConfiguratorServiceSettings, HideObjectsCommand, FilterOperators } from '../../../services/sketchfab/index';
import { Store } from '@/store';
import { ServiceIdentifiers } from '@/services';
import { ComponentContainer } from '@/services/container';

import * as _ from 'lodash';
import ProductSelector from '@/components/productSelector/ProductSelector';
import { ProductDefinition, AnimationDefinition } from '@/models/configuratorx/configuratorSchema';
import Toggle from '@/components/parts/Toggle';

import PartsColor from '@/components/partsColor/PartsColor';



@Component({
  components: {
    toggle: Toggle,
    partsColor: PartsColor,
  },
})
export default class GordionEtajerliMasa extends Vue {
  private _configuratorService: ConfiguratorService = undefined;


  @Inject()
  private _container: ComponentContainer;



  product: ProductDefinition;


  defHideObjects = [
    '_yyy',

  ];

  defShowObjects =  [
    'gordion_masa',
    'gordion_etajer_yyy',
  ];


  seletedPine: string = GordionPine.Normal;


  availableAnimations: AnimationDefinition[] = [];

  private _nodeMap: NodeMap[] = null;
  async created() {
    this.product = Store.getProductById('gordion_etajerli_masa');

    this.availableAnimations =  [];
    this.availableAnimationsChanged();
    this._configuratorService = this._container.get<ConfiguratorService>(ServiceIdentifiers.ConfiguratorService);
    await this._configuratorService.hideObjects({ objects: this.defHideObjects, operator: FilterOperators.Contains });
    await this._configuratorService.showObjects({ objects: this.defShowObjects, operator: FilterOperators.Contains });
    await this._configuratorService.hideObjects({ objects: ['gordion_masa_cam_fume'], operator: FilterOperators.Contains });
    this._nodeMap = await this._configuratorService.Client.getNodeMap();
    const objects = _.filter(this._nodeMap, n => _.includes(n.name, '_yyy') && n.type === 'MatrixTransform');
    console.log(objects);
    _.each(objects, async (obj) => {
      if (!obj) {
        return;
      }
      await this._configuratorService.Client.translate(obj.instanceID, [0, 0, 0], 0.0001, 'easeOutQuad');
    });

    if (Store.state.selection) {

      Store.state.selection.parts.forEach((element) => {
        this.colorChanged(element.color,element.palette,element.id);
      });
      await this.changePine(Store.state.selection.pine);

    } else {
      await  this.applyDefaultSelection();
    }

  }


  availableAnimationsChanged() {

    this.$emit('availableAnimationsChanged', this.availableAnimations);
  }

  async applyDefaultSelection() {
    const selection = new GordionEtajerliMasaSelection();

    selection.parts = [];
    selection.pine = GordionPine.Normal;
    this.product.defaults.parts.forEach((element) => {
      this.colorChanged(element.color,element.palette,element.id);
      const part = new PartSelection();
      part.id = element.id;
      part.color = element.color;
      part.name = element.name;
      part.palette = element.palette;
      selection.parts.push(part);
    });
    Store.state.selection = selection;

  }
  async changePine(pine:GordionPine) {
    if (pine === GordionPine.Fume) {
      await this._configuratorService.hideObjects({ objects: ['gordion_masa_cam_duz'], operator: FilterOperators.Contains });
      await this._configuratorService.showObjects({ objects: ['gordion_masa_cam_fume'], operator: FilterOperators.Contains });
      Store.state.selection.pine = GordionPine.Fume;
      this.seletedPine = GordionPine.Fume;
    }
    if (pine === GordionPine.Normal) {
      await this._configuratorService.hideObjects({ objects: ['gordion_masa_cam_fume'], operator: FilterOperators.Contains });
      await this._configuratorService.showObjects({ objects: ['gordion_masa_cam_duz'], operator: FilterOperators.Contains });
      Store.state.selection.pine = GordionPine.Normal;
      this.seletedPine = GordionPine.Normal;
    }
  }

  async colorChanged(color: any,palette: any,part: any) {

    const getPart = this.product.partsPalettes.find(x => x.part === part);
    const getPalettes = Store.state.configuratorConfig.definitions.palettes.find(x => x.id === palette);
    const getColor = getPalettes.colors.find(col => col.name === color);
    await this._configuratorService.changeAlbedoPBR({
      materials: getPart.materials,
      texture: getColor.texture,
    });
    Store.state.selection.parts.find(x => x.id === part).palette = palette;
    Store.state.selection.parts.find(x => x.id === part).color = color;
  }

}

export class GordionEtajerliMasaSelection {

  pine: GordionPine;
  parts: PartSelection[];
}


export class PartSelection {
  id: string;
  palette: string;
  name: string;
  color: string;

}


enum GordionPine {
  Fume = 'fume',
  Normal = 'normal',

}




// WEBPACK FOOTER //
// ./src/components/families/gordion/GordionEtajerliMasa.ts